import List from './List';
export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-virtual-list@1.1.2@rc-virtual-list/es/index.js
// module id = 474
// module chunks = 0